import { createAction } from '@reduxjs/toolkit';
import * as containerConstants from './constants';
import type { Service, PrintMaterial } from '@/lib/types';

export const loadServices = createAction(containerConstants.LOAD_SERVICES);

export const loadServicesSuccess = createAction(
  containerConstants.LOAD_SERVICES_SUCCESS,
  (services: any[], materials: any[]) => ({
    payload: { services, materials },
  })
);

export const loadServicesError = createAction(
  containerConstants.LOAD_SERVICES_ERROR,
  (error: string) => ({ payload: { error } })
);

export const saveServiceRequest = createAction(
  'services/SAVE_SERVICE_REQUEST',
  (service: Service, isNew: boolean) => ({ payload: { service, isNew } })
);

export const savePrintMaterialRequest = createAction(
  'services/SAVE_PRINT_MATERIAL_REQUEST',
  (material: PrintMaterial, isNew: boolean) => ({ payload: { material, isNew } })
);

export const removePrintMaterialRequest = createAction(
  'services/REMOVE_PRINT_MATERIAL_REQUEST',
  (id: string) => ({ payload: { id } })
);

export const adjustMaterialStockRequest = createAction(
  'services/ADJUST_MATERIAL_STOCK_REQUEST',
  (id: string, change: number, reason: string) => ({ payload: { id, change, reason } })
);
